/** Merged Japanese Near Me copy (flagship wave 1 + wave 2). */
import { NEAR_JA_COPY, type NearJaCopy } from "./ja-copy";
import { NEAR_JA2_COPY } from "./ja-copy-2";
import type { NearJaAnyKey } from "./ja-keys";

export const NEAR_JA_ALL_COPY: Record<NearJaAnyKey, NearJaCopy> = {
  ...NEAR_JA_COPY,
  ...NEAR_JA2_COPY,
};
